var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "query-form",
          attrs: { size: "small", inline: true, model: _vm.searchForm },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.refreshList()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "模型名称", prop: "filterText" } },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "请输入关键词" },
                model: {
                  value: _vm.searchForm.filterText,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "filterText", $$v)
                  },
                  expression: "searchForm.filterText",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh-right" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "top bg-white" },
        [
          _c("vxe-toolbar", {
            attrs: {
              refresh: { query: _vm.refreshList },
              export: "",
              print: "",
              custom: "",
            },
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-plus",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.add()
                          },
                        },
                      },
                      [_vm._v("新建")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "small",
                          icon: "el-icon-delete",
                          disabled:
                            _vm.$refs.modelTable &&
                            _vm.$refs.modelTable.getCheckboxRecords().length ===
                              0,
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.del()
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          disabled:
                            _vm.$refs.modelTable &&
                            _vm.$refs.modelTable.getCheckboxRecords().length !==
                              1,
                          size: "small",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setCategory()
                          },
                        },
                      },
                      [_vm._v("设置分类")]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 80px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "modelTable",
                  attrs: {
                    border: "inner",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {},
                    "export-config": {},
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                },
                [
                  _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "40px" },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "流程名称", field: "name", sortable: "" },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "流程KEY", field: "key", sortable: "" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "分类",
                      field: "procDef.category",
                      sortable: "",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "流程版本",
                      field: "version",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-tag", [
                              _vm._v(_vm._s(scope.row.procDef.version || "0")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "流程状态",
                      field: "version",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.procDef.suspended === false
                                      ? "success"
                                      : scope.row.procDef.suspended ===
                                        undefined
                                      ? "primary"
                                      : "danger",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.procDef.suspended === false
                                      ? "已发布"
                                      : scope.row.procDef.suspended ===
                                        undefined
                                      ? "草稿"
                                      : "已挂起"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "更新时间",
                      field: "lastUpdated",
                      sortable: "",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      width: "200px",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.design(scope.row)
                                  },
                                },
                              },
                              [_vm._v("设计")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deploy(scope.row)
                                  },
                                },
                              },
                              [_vm._v("发布")]
                            ),
                            _c(
                              "el-dropdown",
                              {
                                staticStyle: { "margin-left": "10px" },
                                attrs: { size: "small" },
                              },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { type: "text", size: "small" } },
                                  [
                                    _vm._v(" 更多"),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-arrow-down el-icon--right",
                                    }),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown",
                                  },
                                  [
                                    scope.row.procDef.suspended === true
                                      ? _c(
                                          "el-dropdown-item",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.active(
                                                      scope.row.procDef
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("激活")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    scope.row.procDef.suspended === false
                                      ? _c(
                                          "el-dropdown-item",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.suspend(
                                                      scope.row.procDef
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("挂起")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-dropdown-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.exportXML(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("导出")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copy(scope.row.id)
                                              },
                                            },
                                          },
                                          [_vm._v("复制")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.del(scope.row.id)
                                              },
                                            },
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("vxe-pager", {
                attrs: {
                  background: "",
                  size: "small",
                  "current-page": _vm.tablePage.currentPage,
                  "page-size": _vm.tablePage.pageSize,
                  total: _vm.tablePage.total,
                  "page-sizes": [
                    10,
                    20,
                    100,
                    1000,
                    { label: "全量数据", value: 1000000 },
                  ],
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.currentChangeHandle },
              }),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: {
                title: "查看进度",
                "close-on-click-modal": true,
                visible: _vm.visible,
                height: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c("iframe", {
                attrs: {
                  src: _vm.processPhotoUrl,
                  frameborder: "0",
                  scrolling: "auto",
                  width: "100%",
                  height: "600px",
                },
              }),
            ]
          ),
          _c("model-form", { ref: "modelForm", on: { create: _vm.create } }),
          _c("design-form", {
            ref: "designForm",
            on: { refreshList: _vm.refreshList },
          }),
          _c("category-form", {
            ref: "categoryForm",
            on: { refreshList: _vm.refreshList },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }